// copied from https://github.com/MercuryTechnologies/mercury-web/blob/master/src/utils/unreachableCase.ts
export const unreachableCase = (v: never): never => {
  // in dev, where we let the app build with type errors, this is nicer than `return v`
  throw new Error(`Reached an unreachable case: ${JSON.stringify(v)}`)
}
